document.addEventListener('click', async function (e) {
  const loadMoreBtn = e.target.closest('#load-more-btn');
  if (!loadMoreBtn) return;

  const productGrid = document.querySelector('[id^="ProductGridContainer"] .grid.product-grid');
  if (!productGrid) return;

  let currentPage = parseInt(loadMoreBtn.dataset.currentPage || '1');
  const maxPages = parseInt(loadMoreBtn.dataset.maxPages || '1');
  const totalProducts = parseInt(loadMoreBtn.dataset.totalProducts || '0');

  if (currentPage >= maxPages) return;

  currentPage += 1;
  loadMoreBtn.dataset.currentPage = currentPage;
  loadMoreBtn.disabled = true;
  loadMoreBtn.textContent = 'Loading...';

  try {
    const params = new URLSearchParams(window.location.search);
    params.set('page', currentPage);

    const res = await fetch(window.location.pathname + '?' + params.toString());
    const text = await res.text();
    const html = new DOMParser().parseFromString(text, 'text/html');

    const newItems = html.querySelectorAll('[id^="ProductGridContainer"] .grid.product-grid .grid__item');
    newItems.forEach(item => productGrid.appendChild(item));

    // Update products shown count and progress bar
    const productsShownEl = document.getElementById('products-shown');
    const barEl = document.getElementById('load-more-bar');

    if (productsShownEl && barEl) {
      const currentlyShown = productGrid.querySelectorAll('.grid__item').length;
      productsShownEl.textContent = currentlyShown;

      let percent = (currentlyShown / totalProducts) * 100;
      if (percent > 100) percent = 100;
      barEl.style.width = percent + '%';
    }

    if (currentPage >= maxPages) {
      loadMoreBtn.style.display = 'none';
    } else {
      loadMoreBtn.disabled = false;
      loadMoreBtn.textContent = 'Load More';
    }
  } catch (err) {
    console.error(err);
    loadMoreBtn.disabled = false;
    loadMoreBtn.textContent = 'Load More';
  }
});
